import React, { useState } from "react";
import { usePost } from "seed/api";
import swal from "sweetalert";
import l from "components/util/l";
import { buildChangeViewModel } from "components/util/changes/ChangeView.lib";
import { environmentLabel } from "components/presentation/environments/Environments.lib";
import View from "components/presentation/environments/MergeEnvironment.view";

function MergeEnvironment({ flow, environments }) {

  const [sourceId, setSourceId] = useState(flow.id);
  const [targetId, setTargetId] = useState(environments.find((item) => item.id != flow.id)?.id);
  const [preview, setPreview] = useState(null);

  const [callPreview, reqPreview] = usePost("/flows/merge_environments", {
    onCompleted: (data) => setPreview(data),
    onError: (error) => swal(l("Error%GA114"), error?.detail || l("No se pudo calcular la vista previa%EN024"), "error")
  });

  const [callApply, reqApply] = usePost("/flows/merge_environments", {
    onCompleted: () => window.location.reload(),
    onError: (error) => swal(l("Error%GA114"), error?.detail || l("No se pudo aplicar el merge%EN025"), "error")
  });

  const model = buildChangeViewModel(preview);

  const firstOtherId = (excludedId) => environments.find((item) => item.id != excludedId)?.id;

  const onChangeSource = (value) => {
    setSourceId(value);
    if (value == targetId) setTargetId(firstOtherId(value));
    setPreview(null);
  }

  const onChangeTarget = (value) => {
    setTargetId(value);
    if (value == sourceId) setSourceId(firstOtherId(value));
    setPreview(null);
  }

  const onClickPreview = () =>
    callPreview({ source_id: sourceId, target_id: targetId, mode: "preview" });

  const onClickMerge = () => {
    swal({
      title: l("¿Estás seguro de desplegar {source} en {target}?%EN032", {
        source: environmentLabel(environments.find((item) => item.id == sourceId)),
        target: environmentLabel(environments.find((item) => item.id == targetId))
      }),
      icon: "warning",
      buttons: {
        confirm: { text: l("Aceptar%GA020"), className: "swal-button swal-button--cancel btn-success" },
        cancel: l("Cancelar%GA021")
      }
    }).then((willMerge) => {
      if (!willMerge) return;
      callApply({ source_id: sourceId, target_id: targetId, mode: "apply" });
    });
  }

  return (
    <View
      environments={environments}
      sourceId={sourceId}
      targetId={targetId}
      preview={preview}
      isEmpty={model.isEmpty}
      isLoadingPreview={reqPreview.loading}
      isApplying={reqApply.loading}
      onChangeSource={onChangeSource}
      onChangeTarget={onChangeTarget}
      onClickPreview={onClickPreview}
      onClickMerge={onClickMerge}
    />
  );

}

export default MergeEnvironment;
